var _path, _path2, _circle, _circle2, _circle3, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.276,51.724c-0,-2.857 -2.316,-5.172 -5.173,-5.172l-237.931,-0c-2.856,-0 -5.172,2.315 -5.172,5.172l0,62.069c0,2.857 2.316,5.172 5.172,5.172l237.931,0c2.857,0 5.173,-2.315 5.173,-5.172l-0,-62.069Zm-237.931,5.172l-0,51.725l227.586,-0l0,-51.725l-227.586,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.759,72.414c-0,-2.857 -2.316,-5.173 -5.173,-5.173l-51.724,0c-2.857,0 -5.172,2.316 -5.172,5.173l-0,20.69c-0,2.856 2.315,5.172 5.172,5.172l51.724,-0c2.857,-0 5.173,-2.316 5.173,-5.172l-0,-20.69Zm-51.725,5.172l0,10.345l41.38,0l-0,-10.345l-41.38,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.655,
    cy: 93.103,
    r: 5.172
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.345,
    cy: 93.103,
    r: 5.172
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.034,
    cy: 93.103,
    r: 5.172
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 196.552,
    y: 87.931,
    width: 20.69,
    height: 10.345
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.278,98.276l15.032,-0c5.731,-0 10.345,4.614 10.345,10.345l0,41.379c0,5.731 -4.614,10.345 -10.345,10.345l-97.306,-0c-2.854,-0 -5.172,2.317 -5.172,5.172c0,2.855 2.318,5.173 5.172,5.173l97.306,-0c11.462,-0 20.69,-9.228 20.69,-20.69c0,-0 0,-41.379 0,-41.379c0,-11.462 -9.228,-20.69 -20.69,-20.69l-15.032,-0c-2.855,-0 -5.172,2.318 -5.172,5.172c-0,2.855 2.317,5.173 5.172,5.173Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.966,82.759c-0,-2.857 -2.316,-5.173 -5.173,-5.173l-20.69,0c-2.856,0 -5.172,2.316 -5.172,5.173l0,20.689c0,2.857 2.316,5.172 5.172,5.172l20.69,0c2.857,0 5.173,-2.315 5.173,-5.172l-0,-20.689Zm-20.69,5.172l-0,10.345l10.345,-0l-0,-10.345l-10.345,-0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.754,212.068l-20.616,-0c-2.855,-0 -5.172,2.318 -5.172,5.172c-0,2.855 2.317,5.173 5.172,5.173l20.616,-0c2.855,-0 5.172,-2.318 5.172,-5.173c0,-2.854 -2.317,-5.172 -5.172,-5.172Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.754,232.759l-20.616,-0c-2.855,-0 -5.172,2.317 -5.172,5.172c-0,2.855 2.317,5.172 5.172,5.172l20.616,0c2.855,0 5.172,-2.317 5.172,-5.172c0,-2.855 -2.317,-5.172 -5.172,-5.172Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.759,201.724c-2.857,0 -5.173,2.316 -5.173,5.172l0,41.38c0,2.857 2.316,5.172 5.173,5.172l41.379,0c2.857,0 5.172,-2.315 5.172,-5.172l0,-41.38c0,-2.856 -2.315,-5.172 -5.172,-5.172l-41.379,0Zm5.172,10.345l0,31.035l31.035,-0l-0,-31.035l-31.035,-0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.069,212.069c-2.857,-0 -5.172,2.316 -5.172,5.172l-0,20.69c-0,2.857 2.315,5.172 5.172,5.172l20.69,0c2.856,0 5.172,-2.315 5.172,-5.172l0,-20.69c0,-2.856 -2.316,-5.172 -5.172,-5.172l-20.69,-0Zm5.172,10.345l0,10.345l10.345,-0l0,-10.345l-10.345,-0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.584,222.413l-190.894,-0c-5.731,-0 -10.345,-4.614 -10.345,-10.345l-0,-31.034c-0,-5.731 4.614,-10.344 10.345,-10.344c-0,-0 173.599,-0 173.599,-0c2.854,-0 5.172,-2.318 5.172,-5.173c0,-2.855 -2.318,-5.172 -5.172,-5.172l-173.599,-0c-11.462,-0 -20.69,9.227 -20.69,20.689c0,0 0,31.034 0,31.034c0,11.462 9.228,20.69 20.69,20.69c-0,-0 190.894,-0 190.894,-0c2.855,-0 5.172,-2.318 5.172,-5.173c0,-2.855 -2.317,-5.172 -5.172,-5.172Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalTv);
export default __webpack_public_path__ + "static/media/digital_tv.0feb799f.svg";
export { ForwardRef as ReactComponent };